import React from 'react';
import ReactDOM from 'react-dom';
import { QRCode } from 'react-qr-svg';
    
export default class QRCodeCupomEncomenda extends React.Component {
    constructor(props) {
        super(props);
        this.imgRef = React.createRef();
    }

    componentDidMount() {
        const tempDiv = document.createElement('div');
        document.body.appendChild(tempDiv);

        ReactDOM.render(
            <QRCode level="Q" value={`${this.props.encomenda.idPedido}`} />,
            tempDiv,
            () => {
                const svg = tempDiv.querySelector('svg');
                const serializer = new XMLSerializer();
                const svgStr = serializer.serializeToString(svg);
                const img = this.imgRef.current;
                img.src = 'data:image/svg+xml;base64,' + window.btoa(svgStr);

                ReactDOM.unmountComponentAtNode(tempDiv);
                document.body.removeChild(tempDiv);
            }
        );
    }

    render() {
        return <img ref={this.imgRef} width="160" height="160" />;
    }
}
